// extracted by mini-css-extract-plugin
export default {"wide":"PageContainer_wide__ZUB90","centered":"PageContainer_centered__sTLsj","all-containers":"PageContainer_all-containers__gU0Hh"};